import React, { useState, useEffect } from "react";
import Header from "../../Core/Header";
import axios from "axios";
import Cookies from "js-cookie";
import { categoryAssign, userAdd, userList, userOtp, userOtpVerify } from "../../Services/Operations/ProductAPI";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { setLoginData } from "../../Redux/user_information";
import { useNavigate } from "react-router-dom";
import { Section } from "../../Core/Section";
import { useSelector } from "react-redux";
import { Button, Modal } from "react-bootstrap";

const ChamberAdd = () => {
  const token = useSelector((state) => state.user.token);
    const [showOtpSection, setShowOtpSection] = useState(false);
  const [otp, setOtp] = useState(["", "", "", ""]);
  console.log("token : ", token);
  const [user, setUser] = useState([]);
  const [profileImage,setProfileImage]=useState(null)
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const[showModal,setShowModal]=useState(false)
  const [selectedUser,setSelectedUser]=useState(null)
  const [cartUpdated, setUserUpdated] = useState(false);
 const roleId= Cookies.get("role")
 const [userselectId, setUserselectId] = useState("");
  const [formData, setFormData] = useState({
    firstName: "",
    middleName: "",
    lastName: "",
    dob: "",
    age: "",
    gender: "",
    co: "",
    houseBuildingApartment: "",
    streetRoadLane: "",
    landmark: "",
    areaLocalitySector: "",
    villageTownCity: "",
    postOffice: "",
    district: "",
    subDistrict: "",
    state: "",
    pincode: "",
    primaryNumber: "",
    secondaryNumber: "",
    email: "",
  
  });

   const [secondformData, setSecondFormData] = useState({
   shopName:"",
       shopAddress:"",
       shopOwnerGstNumber:"",
       latitude:"",
       longitude:"",
       bankName:"",
       bankBranch:"",
       bankAccountNumber:"",
      ifscCode:"",
       upiId:"",
       shopLogoFile:"",
       IdentityImage:"",
  
  });

  const[formType,setFormType]=useState(1)

// //    "shopName",
//       "shopAddress",
//       "shopOwnerGstNumber",
//       "bankName",
//       "bankBranch",
//       "bankAccountNumber",
//       "ifscCode",
//       "upiId",
//       "shopLogoFile",
//       "IdentityImage",

  const [errors, setErrors] = useState({
  primaryNumber: "",
});

   const handleViewDetails = (user) => {
    setSelectedUser(user);
    setShowModal(true);
  };
  const handleCloseModal=()=>{
    setShowModal(false)
    setSelectedUser(null)
  }

  const handleChange = (e) => {

     if (e.target.name === "primaryNumber" && !/^\d*$/.test(e.target.value)) {
    return;
  }

    setFormData({ ...formData, [e.target.name]: e.target.value });

   
  };

  const handleBlur = (e) => {
  const { name, value } = e.target;

  if (name === "primaryNumber") {
    if (value.length < 10) {
      toast.error('Number should be in 10 digits')
    } else if (value.length > 10) {
      toast.error('Numbers are more than 10 digits')
    }
  }
};

  const handleSubmit = async (e) => {
    e.preventDefault();
   
    try {
       const response = await userOtp(formData?.primaryNumber, token);
       console.log("response of user added:", response);
       if (response.status === 200) {
         console.log("don1", response.data.id);
          toast.success(response.data);
        //  dispatch(setLoginData(response.data.id));
          setShowOtpSection(true);
        //  setUserUpdated((prev) => !prev);
        alert("otp:",response.data.data.otp)
       } else {
         console.log("don", response.message);
         toast.error(response.data.message);
       }
       
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleSecondFormSubmit = async(e) => {
  e.preventDefault();

  // Add your API submission logic here
  console.log("Second Form Data:", secondformData);

  const formDataToSend = new FormData();
        Object.entries(secondformData).forEach(([key, value]) => {
        if (
          value !== null &&
          value !== undefined &&
          value !== "" &&
          !(typeof value === "object" && Object.keys(value).length === 0)
        ) {
            if (key === 'refferedBy' || key === 'reffer') return;
          const modifiedKey = ["shopName", "shopAddress","latitude","longitude"].includes(key)
            ? `shopDetails.${key}`
            : key;

          formDataToSend.append(modifiedKey, value);
          
        }
      });
       if (userselectId) {
        formDataToSend.append("commonUserId", userselectId);
      }

        for (let [key, value] of formDataToSend.entries()) {
  console.log(key, value);
} 

                const response = await categoryAssign(formDataToSend, 8, token);
                   console.log(response);

                   if (response.status === 200) {
                           toast.success("User Allocation added successfully");
                           navigate("/doctor")

                   }
      
};



  useEffect(() => {
    const fetchUserList = async () => {
      try {
        const response = await userList(token);
        console.log("user list:", response);
        setUser(response);
      } catch (error) {
        console.error("Error updating profile:", error);
      }
    };

    fetchUserList();
  }, [cartUpdated]);

  const handleAddRole = (id) => {
    console.log("Id : ", id);
  setUserselectId(id)

    setFormType(2)
  };

    const handleOtpChange = (index, value) => {
    if (!/^\d?$/.test(value)) return; // Only allow digits
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && index < 5) {
      const nextInput = document.getElementById(`otp-${index + 1}`);
      if (nextInput) nextInput.focus();
    }
  };

 const handleOtpSubmit = async () => {
  const enteredOtp = otp.join("");
  const phone = formData.primaryNumber;

  if (enteredOtp.length === 4 && phone) {
    try {
      const formDataToSend = new FormData();
       formDataToSend.append('profileImageFile',profileImage)
      Object.entries(formData).forEach(([key, value]) => {
        formDataToSend.append(key, value);
      });
 console.log("formDataToSend",formDataToSend);
 
      formDataToSend.append("otp", enteredOtp);
          formDataToSend.append("roleId", roleId);
      const result = await userAdd(formDataToSend, token);
      console.log("OTP verification response:", result);
      if (result.status === 200) {
         console.log("don1", result.data.id);
         
          toast.success("User added successully");
          dispatch(setLoginData(result.data.id));
          setUserUpdated((prev) => !prev);
        handleAddRole(Number(result.data.id)) // to allocate to a specific role
       } else {
         console.log("don", result.message);
         toast.error(result.data);
       }
       
    } catch (error) {
      console.error("Error verifying OTP:", error);
    }
  } else {
    alert("Please enter a valid phone number and a 6-digit OTP");
  }
};



  return (
    <div id="main_content">
      <Header />
      <div className="page">
        <Section />
        <div className="section-body">
          <div className="container-fluid">
            <div className="d-flex justify-content-between align-items-center ">
              <div className="header-action">
                <h1 className="page-title">Register Chamber</h1>
                <ol className="breadcrumb page-breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="#">RNDSAN</a>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Chamber
                  </li>
                </ol>
              </div>
              <ul className="nav nav-tabs page-header-tab">
               
             
              </ul>
            </div>
          </div>
        </div>
        <div className="section-body mt-4">
          <div className="container-fluid">
            <div className="tab-content">
           

          


              <div className="tab-pane active" id="Student-add">
                <div className="row clearfix">
                  <div className="col-lg-8 col-md-12 col-sm-12">

                    {/* thi sis the section if owner register then a form and when chamber reister then another form */}
                  { formType===1? <div className="card">
                      <div className="card-header">
                        <h3 className="card-title">Chamber Owner Information</h3>
                        <div className="card-options ">
                        
                        </div>
                      </div>
                       {!showOtpSection ? (
                      <form className="card-body" onSubmit={handleSubmit}>
                        {Object.keys(formData).map((field) => (
                          <div className="form-group row" key={field}>
                            <label className="col-md-3 col-form-label">
                              {field
                                .replace(/([A-Z])/g, " $1")
                                .replace(/^./, (str) => str.toUpperCase())}
                              {field !== "middleName" &&
                              field !== "secondaryNumber" &&
                              field !== "co" &&
                              field !== "landmark" ? (
                                <span className="text-danger">*</span>
                              ) : null}
                            </label>
                            <div className="col-md-9">
                              {field === "gender" ? (
                                <select
                                  className="form-control"
                                  name={field}
                                  value={formData[field]}
                                  onChange={handleChange}
                                  required
                                >
                                  <option value="">Select Gender</option>
                                  <option value="Male">Male</option>
                                  <option value="Female">Female</option>
                                  <option value="Other">Other</option>
                                </select>
                              ) : field === "pincode" ? (
                                <input
                                  type="text"
                                  className="form-control"
                                  name="pincode"
                                  placeholder="Enter pincode"
                                  value={formData["pincode"]}
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    if (/^\d{0,6}$/.test(value)) {
                                      handleChange(e);
                                    }
                                  }}
                                  required
                                  maxLength={6}
                                  pattern="^\d{6}$"
                                  title="Pincode must be exactly 6 digits"
                                />
                              ) : field === "co" ? (
                                <input
                                  type="text"
                                  className="form-control"
                                  name="co"
                                  placeholder="Enter co"
                                  value={formData["co"]}
                                  onChange={handleChange}
                                  onKeyPress={(e) => {
                                    if (/\d/.test(e.key)) {
                                      e.preventDefault();
                                    }
                                  }}
                                  pattern="^[A-Za-z\s]+$"
                                  title="Only alphabetic characters and spaces allowed"
                                />
                              ) : field === "dob" ? (
                                <input
                                  type="date"
                                  className="form-control"
                                  name={field}
                                  placeholder="Enter date of birth"
                                  value={formData[field]}
                                  onChange={(e) => {
                                    handleChange(e);

                                    if (e.target.value) {
                                      const birthDate = new Date(
                                        e.target.value
                                      );
                                      const today = new Date();
                                      let age =
                                        today.getFullYear() -
                                        birthDate.getFullYear();
                                      const monthDiff =
                                        today.getMonth() - birthDate.getMonth();

                                      if (
                                        monthDiff < 0 ||
                                        (monthDiff === 0 &&
                                          today.getDate() < birthDate.getDate())
                                      ) {
                                        age--;
                                      }

                                      setFormData((prev) => ({
                                        ...prev,
                                        age: age.toString(),
                                      }));
                                    }
                                  }}
                                  required
                                />
                              ) : field === "age" ? (
                                <input
                                  type="number"
                                  className="form-control"
                                  name={field}
                                  placeholder="Age"
                                  value={formData[field]}
                                  readOnly
                                />
                              ) : (
                                <input
                                  type={
                                    field === "password"
                                      ? "password"
                                      : field === "email"
                                      ? "email":
                                      field==="profileImage"?
                                      "file"
                                      : "text"
                                  }
                                  className="form-control"
                                  name={field}
                                  placeholder={`Enter ${field
                                    .replace(/([A-Z])/g, " $1")
                                    .toLowerCase()}`}
                                  value={formData[field]}
                                  onChange={ handleChange}
                                  required={
                                    field !== "middleName" &&
                                    field !== "secondaryNumber" &&
                                    field !== "co" &&
                                    field !== "landmark"
                                  }
                                  onBlur={handleBlur}
                                />
                              )}
                            </div>
                          </div>
                        ))}

                            <div className="form-group row" >
                            <label className="col-md-3 col-form-label">
                              Profile Image  <span className="text-danger">*</span>
                            </label>
                            <input type='file' onChange={(e)=>setProfileImage(e.target.files[0])}/>
                            </div>

                        <div className="col-sm-12">
                          <button type="submit" className="btn btn-primary">
                            Submit
                          </button>
                        </div>
                      </form>
                       ) : (
        <div className="otp-section card p-4">
          <h4 className="text-center mb-4">Enter OTP</h4>
          <div className="otp-inputs d-flex justify-content-center mb-3">
            {otp.map((digit, index) => (
              <input
              
                id={`otp-${index}`}
                type="text"
                maxLength="1"
                className="otp-box"
                value={digit}
                onChange={(e) => handleOtpChange(index, e.target.value)}
              />
            ))}
          </div>
          <div className="text-center">
            <button className="btn btn-success" onClick={handleOtpSubmit}>
              Verify OTP
            </button>
          </div>
        </div>
      )}
                    </div>
                    :
                    <div className="card">
  <div className="card-header">
    <h3 className="card-title">Chamber Details & Bank Information</h3>
    <div className="card-options"></div>
  </div>

  <form className="card-body" onSubmit={handleSecondFormSubmit}>
    {Object.keys(secondformData).map((field) => (
      <div className="form-group row" key={field}>
        <label className="col-md-3 col-form-label">
          {field
            .replace(/([A-Z])/g, " $1")
            .replace(/^./, (str) => str.toUpperCase())}

          {field !== "shopOwnerGstNumber" &&
          field !== "upiId" &&
          field !== "shopLogoFile" &&
          field !== "IdentityImage" ? (
            <span className="text-danger">*</span>
          ) : null}
        </label>

        <div className="col-md-9">
          {field === "shopLogoFile" || field === "IdentityImage" ? (
            <input
              type="file"
              className="form-control"
              name={field}
              accept="image/*"
              onChange={(e) => {
                setSecondFormData((prev) => ({
                  ...prev,
                  [field]: e.target.files[0] || "",
                }));
              }}
            />
          ) : (
            <input
              type="text"
              className="form-control"
              name={field}
              placeholder={`Enter ${field
                .replace(/([A-Z])/g, " $1")
                .toLowerCase()}`}
              value={secondformData[field]}
              onChange={(e) =>
                setSecondFormData((prev) => ({
                  ...prev,
                  [field]: e.target.value,
                }))
              }
              required={
                field !== "shopOwnerGstNumber" &&
                field !== "upiId"
              }
            />
          )}
        </div>
      </div>
    ))}

    <div className="col-sm-12">
      <button type="submit" className="btn btn-primary">
        Submit
      </button>
    </div>
  </form>
                    </div>}

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="section-body">
          <footer className="footer">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-6 col-sm-12">
                  Copyright © 2025{" "}
                  <a href="">Technology support By - Siance Software Pvt Ltd</a>
                  .
                </div>
                {/* <div className="col-md-6 col-sm-12 text-md-right">
                  <ul className="list-inline mb-0">
                    <li className="list-inline-item">
                      <a href="../doc/index.html">Documentation</a>
                    </li>
                    <li className="list-inline-item">
                      <a href="javascript:void(0)">FAQ</a>
                    </li>
                    <li className="list-inline-item">
                      <a
                        href="javascript:void(0)"
                        className="btn btn-outline-primary btn-sm"
                      >
                        Buy Now
                      </a>
                    </li>
                  </ul>
                </div> */}
              </div>
            </div>
          </footer>
        </div>

         <Modal show={showModal} onHide={handleCloseModal} size="md">
                  <Modal.Header closeButton>
                    <Modal.Title>Category Details</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    {selectedUser ? (
                      <div>
                        <p>
                          <strong>ID:</strong> {selectedUser.id}
                        </p>
                        <p>
                          <strong> Name:</strong>{" "}
                          {selectedUser.firstName} {"  "}{selectedUser.firstName}{"  " }{selectedUser.firstName}
                        </p>
                        <p>
                          <strong>Primary number:</strong>{" "}
                          {selectedUser.primaryNumber}
                        </p>
                        <p>
                          <strong>Email:</strong>{" "}
                          {selectedUser.email}
                        </p>
                         <p>
                          <strong>Date of birth:</strong>{" "}
                          {selectedUser.dob[0]}/{selectedUser.dob[1]}/{selectedUser.dob[2]}
                        </p>
                        <p>
                          <strong>
                            Address:
                          </strong>
                          {selectedUser.houseBuildingApartment},{selectedUser.areaLocalitySector},{selectedUser.pincode}
                        </p>
                      </div>
                    ) : (
                      <p>No details available</p>
                    )}
                  </Modal.Body>
                  <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseModal}>
                      Close
                    </Button>
                  </Modal.Footer>
                </Modal>
      </div>
    </div>
  );
};
export default ChamberAdd;
